/*jshint esversion: 11 */
import React from 'react';
import { Row, Col, Table } from 'reactstrap';
import moment from 'moment';

const dayLabels = {
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat'
};

const daysOfWeek = Object.keys(dayLabels);

const WeeklyLogDetailsView = ({ record, forExport = false }) => {
  if (!record) {
    return null;
  }

  const tableStyle = forExport
    ? { width: '100%', tableLayout: 'fixed', fontSize: '12px' }
    : undefined;

  const cellStyle = forExport
    ? { wordBreak: 'break-word', verticalAlign: 'top', padding: '6px' }
    : undefined;

  return (
    <div
      className={forExport ? 'weekly-log-pdf-export' : undefined}
      style={
        forExport
          ? {
              backgroundColor: '#ffffff',
              padding: '16px',
              color: '#000000'
            }
          : undefined
      }
    >
      {forExport && (
        <h4 style={{ marginBottom: '16px', fontSize: '18px' }}>
          Weekly Log
          {record.batch?.name ? ` - ${record.batch.name}` : ''}
        </h4>
      )}
      <Row className="mb-3">
        <Col md={4}>
          <strong>Offering:</strong> {record.offering?.name || 'N/A'}
        </Col>
        <Col md={4}>
          <strong>Batch:</strong> {record.batch?.name || 'N/A'}
        </Col>
        <Col md={4}>
          <strong>Week:</strong>{' '}
          {record.start_date
            ? `${moment(record.start_date).format('DD MMM YYYY')} - ${moment(
                record.end_date
              ).format('DD MMM YYYY')}`
            : 'N/A'}
        </Col>
      </Row>

      <h6>Daily Activities</h6>
      <div className={forExport ? 'mb-4' : 'table-responsive mb-4'}>
        <Table bordered style={tableStyle}>
          <thead>
            <tr>
              <th style={cellStyle}>Activity</th>
              {daysOfWeek.map((day) => (
                <th key={day} style={cellStyle}>
                  {dayLabels[day]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {record.daily_activities?.length ? (
              record.daily_activities.map((activity, idx) => (
                <tr key={idx}>
                  <td style={cellStyle}>{activity.activity}</td>
                  {daysOfWeek.map((day) => (
                    <td key={`${day}-${idx}`} style={cellStyle}>
                      {activity.activity_execution?.[day] || '-'}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center" style={cellStyle}>
                  No daily activities
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <h6>Weekly Activities</h6>
      <div className={forExport ? undefined : 'table-responsive'}>
        <Table bordered style={tableStyle}>
          <thead>
            <tr>
              <th style={cellStyle}>Activity</th>
              <th style={cellStyle}>Work Done</th>
            </tr>
          </thead>
          <tbody>
            {record.weekly_activities?.length ? (
              record.weekly_activities.map((activity, idx) => (
                <tr key={idx}>
                  <td style={cellStyle}>{activity.activity}</td>
                  <td style={cellStyle}>{activity.activity_execution || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="text-center" style={cellStyle}>
                  No weekly activities
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default WeeklyLogDetailsView;
